import {
  CompositionEffect,
  DIRECTION_HORIZONTAL,
  DIRECTION_HORIZONTAL_INVERTED,
  DIRECTION_VERTICAL,
  DIRECTION_VERTICAL_INVERTED,
  DURATION_LONG,
  EASING_BEZIER_IN_BOUNCE,
  EASING_BEZIER_IN_CUBIC,
  EASING_BEZIER_OUT_BOUNCE,
  EASING_BEZIER_OUT_CUBIC
} from './CompositionEffect';
import { PropertyType } from '@beatflyer/shaders-lib';

const curveIn = EASING_BEZIER_OUT_CUBIC;
const curveOut = EASING_BEZIER_IN_CUBIC;

const bounceIn = EASING_BEZIER_OUT_BOUNCE;
const bounceOut = EASING_BEZIER_IN_BOUNCE;

class Composition extends CompositionEffect {
  static id = 'composition-scroll';
  static label = 'Scroll';

  protected compose(position: number) {
    const { stageWidth, stageHeight, sprite } = this.layer;
    const bounce = this.getProperty('bounce') as boolean;
    const easing = bounce ? bounceIn : curveIn;
    const p = easing(position);
    const direction = this.getProperty('direction') as string;
    switch (direction) {
      case DIRECTION_VERTICAL:
        sprite.compositionTransform.position.set(0, (1 - p) * stageHeight);
        break;
      case DIRECTION_VERTICAL_INVERTED:
        sprite.compositionTransform.position.set(0, -(1 - p) * stageHeight);
        break;
      case DIRECTION_HORIZONTAL:
        sprite.compositionTransform.position.set(-(1 - p) * stageWidth, 0);
        break;
      case DIRECTION_HORIZONTAL_INVERTED:
        sprite.compositionTransform.position.set((1 - p) * stageWidth, 0);
        break;
      default:
        break;
    }
  }
  protected decompose(position: number) {
    const { stageWidth, stageHeight, sprite } = this.layer;
    const bounce = this.getProperty('bounce') as boolean;
    const easing = bounce ? bounceOut : curveOut;
    const p = easing(position);
    const direction = this.getProperty('direction') as string;
    switch (direction) {
      case DIRECTION_VERTICAL:
        sprite.compositionTransform.position.set(0, -p * stageHeight);
        break;
      case DIRECTION_VERTICAL_INVERTED:
        sprite.compositionTransform.position.set(0, p * stageWidth);
        break;
      case DIRECTION_HORIZONTAL:
        sprite.compositionTransform.position.set(p * stageWidth, 0);
        break;
      case DIRECTION_HORIZONTAL_INVERTED:
        sprite.compositionTransform.position.set(-p * stageWidth, 0);
        break;
      default:
        break;
    }
  }

  getInitialDuration(): string {
    return DURATION_LONG;
  }

  getPropertiesDescriptors() {
    const parentDescriptors = super.getPropertiesDescriptors();
    return {
      ...parentDescriptors,
      direction: {
        type: PropertyType.SELECT,
        options: [
          DIRECTION_VERTICAL,
          DIRECTION_VERTICAL_INVERTED,
          DIRECTION_HORIZONTAL,
          DIRECTION_HORIZONTAL_INVERTED
        ],
        initialValue: DIRECTION_VERTICAL
      },
      bounce: {
        type: PropertyType.BOOLEAN,
        initialValue: false
      }
    };
  }
}

(window as any).BeatFlyer.compositions[Composition.id] = Composition;



// WEBPACK FOOTER //
// ./src/compose/ComposeScroll.ts